// Retailers each novel is published on, keyed by the novel id used in
// pages/LandingPage.jsx. A novel with no entry here simply shows no buy button.
// Static requires so webpack resolves each logo individually rather than
// bundling the whole folder through a context module.
const STORES = {
  amazon: { name: "Amazon", logo: require("../assets/StoreLogos/amazon.png") },
  apple: { name: "Apple Books", logo: require("../assets/StoreLogos/apple.png") },
  barnesnoble: { name: "Barnes & Noble", logo: require("../assets/StoreLogos/barnesnoble.png") },
  bookshop: { name: "Bookshop.org", logo: require("../assets/StoreLogos/bookshop.png") },
  everand: { name: "Everand", logo: require("../assets/StoreLogos/everand.png") },
  fable: { name: "Fable", logo: require("../assets/StoreLogos/fable.png") },
  kobo: { name: "Kobo", logo: require("../assets/StoreLogos/kobo.png") },
  smashwords: { name: "Smashwords", logo: require("../assets/StoreLogos/smashwords.png") },
  thalia: { name: "Thalia", logo: require("../assets/StoreLogos/thalia.png") },
  vivlio: { name: "Vivlio", logo: require("../assets/StoreLogos/vivlio.png") },
};

const build = (entries) =>
  entries.map(([key, url]) => ({ ...STORES[key], key, url }));

// KDP's shareable link for an ASIN; it redirects readers to amazon.com/dp/<asin>
const amazon = (asin) =>
  `https://kdp.amazon.com/amazon-dp-action/us/dualbookshelf.marketplacelink/${asin}`;

export const STORE_LINKS = {
  // Gareth & Bart Novels — not on Apple Books
  "Gareth-Bath-novels": build([
    ["amazon", amazon("B0GX3B6BRD")],
    ["barnesnoble", "https://www.barnesandnoble.com/w/gareth-bart-novels-sean-mcfirnn/1148476651?ean=2940196888212"],
    ["bookshop", "https://bookshop.org/p/books/gareth-bart-novels-sean-mcfirnn/2d63566dc653d396?ean=9798235188365"],
    ["everand", "https://www.everand.com/book/1064296578/Gareth-Bart-Novels"],
    ["fable", "https://fable.co/book/x-9798235188365"],
    ["kobo", "https://www.kobo.com/us/en/ebook/gareth-bart-novels?sId=7b9e50bc-dd0b-4da0-a4c2-69378e4b3eec&ssId=t0AqIJbLXvYt1y9H41un2"],
    ["smashwords", "https://www.smashwords.com/books/view/2070179"],
    ["thalia", "https://www.thalia.de/shop/home/artikeldetails/A1081001229"],
    ["vivlio", "https://shop.vivlio.com/product/9798235188365_9798235188365_10020/gareth-amp-bart-novels"],
  ]),

  // The Aussie's Spartan-Games
  "8f7d9a62-3b1e-4e8a-9c5d-2f8b7a3e4d1c": build([
    ["amazon", amazon("B0CWFFMR47")],
    ["apple", "https://books.apple.com/us/book/the-aussies-spartan-games/id6792098700"],
    ["barnesnoble", "https://www.barnesandnoble.com/w/the-aussies-spartan-games-sean-mcfirnn/1150827370?ean=2940196729751"],
    ["bookshop", "https://bookshop.org/p/books/the-aussie-s-spartan-games-sean-mcfirnn/41e6a7ca13fa7b36?ean=9798235192515"],
    ["everand", "https://www.everand.com/book/1063280005/The-Aussie-s-Spartan-Games"],
    ["fable", "https://fable.co/book/x-9798235192515"],
    ["kobo", "https://www.kobo.com/us/en/ebook/the-aussie-s-spartan-games?sId=3cf8ace6-a542-4fb8-9177-6e063a918c53&ssId=7UGH4UuD_niYab4zszOrz"],
    ["smashwords", "https://www.smashwords.com/books/view/2068347"],
    ["thalia", "https://www.thalia.de/shop/home/artikeldetails/A1080964830"],
    ["vivlio", "https://shop.vivlio.com/product/9798235192515_9798235192515_10020/the-aussies-spartan-games"],
  ]),

  // We Won't Die Wondering — Amazon only
  "2c4a6b8d-5e7f-4a9b-8c1d-3e5f7a9b2c4d": build([
    ["amazon", amazon("B0CW1LP1R1")],
  ]),

  // The Roman-Death Of A Greek-Slave
  "1a3b5c7d-9e2f-4b6d-8a0c-2e4f6g8h0j2k": build([
    ["amazon", amazon("B0CW1DWT3K")],
    ["apple", "https://books.apple.com/us/book/the-roman-death-of-a-greek-slave/id6792099120"],
    ["barnesnoble", "https://www.barnesandnoble.com/w/the-roman-death-of-a-greek-slave-sean-mcfirnn/1150827374?ean=2940196108488"],
    ["bookshop", "https://bookshop.org/p/books/the-roman-death-of-a-greek-slave-sean-mcfirnn/c99e868124417e7b?ean=9798235141377"],
    ["everand", "https://www.everand.com/book/1063292485/The-Roman-Death-Of-A-Greek-Slave"],
    ["fable", "https://fable.co/book/x-9798235141377"],
    ["kobo", "https://www.kobo.com/us/en/ebook/the-roman-death-of-a-greek-slave?sId=44d99992-50d9-41a3-b6c5-2b7b167ff664&ssId=xqOZbTeoHNrlA_oCVV9ee"],
    ["smashwords", "https://www.smashwords.com/books/view/2068355"],
    ["thalia", "https://www.thalia.de/shop/home/artikeldetails/A1080964523"],
    ["vivlio", "https://shop.vivlio.com/product/9798235141377_9798235141377_10020/the-roman-death-of-a-greek-slave"],
  ]),

  // A Cattle-Station Faggot
  "5d7e9f2a-4b6c-8d0e-2f4g-6h8j0k2l4m6n": build([
    ["amazon", amazon("B0CW1L7F4Q")],
    ["apple", "https://books.apple.com/us/book/a-cattle-station-f-t/id6792099410"],
    ["barnesnoble", "https://www.barnesandnoble.com/w/a-cattle-station-faggot-sean-mcfirnn/1150827161?ean=2940196149733"],
    ["bookshop", "https://bookshop.org/p/books/a-cattle-station-faggot-sean-mcfirnn/3dd93e152c632417?ean=9798235755499"],
    ["everand", "https://www.everand.com/book/1063279982/A-CATTLE-STATION-FAGGOT"],
    ["fable", "https://fable.co/book/x-9798235755499"],
    ["kobo", "https://www.kobo.com/search?query=9798235755499"],
    ["smashwords", "https://www.smashwords.com/books/view/2068339"],
    ["thalia", "https://www.thalia.de/shop/home/artikeldetails/A1080964823"],
    ["vivlio", "https://shop.vivlio.com/product/9798235755499_9798235755499_10020/a-cattle-station-faggot"],
  ]),

  // Dan Ericson: Norwegian Cop — Amazon only
  "3f5g7h9j-2k4l-6m8n-0p2q-4r6s8t0u2v4w": build([
    ["amazon", amazon("B0CW9KJMWG")],
  ]),

  // Mutilations
  "7k9l2m4n-6p8q-0r2s-4t6u-8v0w2x4y6z8a": build([
    ["amazon", amazon("B0CW1G3TDX")],
    ["apple", "https://books.apple.com/us/book/mutilations/id6792172273"],
    ["barnesnoble", "https://www.barnesandnoble.com/w/mutilations-sean-mcfirnn/1150829845?ean=2940196591556"],
    ["bookshop", "https://bookshop.org/p/books/mutilations-sean-mcfirnn/5360773cb49c54dd?ean=9798233757693"],
    ["everand", "https://www.everand.com/book/1063335704/MUTILATIONS"],
    ["fable", "https://fable.co/book/x-9798233757693"],
    ["kobo", "https://www.kobo.com/us/en/ebook/mutilations?sId=8e132475-7100-413d-90b1-0449ab717c53&ssId=EEnqx5Z7_l59HZ1e_FEUq"],
    ["smashwords", "https://www.smashwords.com/books/view/2068544"],
    ["thalia", "https://www.thalia.de/shop/home/artikeldetails/A1080964575"],
    ["vivlio", "https://shop.vivlio.com/product/9798233757693_9798233757693_10020/mutilations"],
  ]),

  // The Perfect-S Collection — Vivlio has no product page, only a search result
  "5d7e9f2a-4b6c-8d0e-2f4g-6h8j0k2l4m7d": build([
    ["amazon", amazon("B0GX31SS4V")],
    ["apple", "https://books.apple.com/us/book/the-perfect-s-collection-by-sean-mcfirnn-collection/id6792099329"],
    ["barnesnoble", "https://www.barnesandnoble.com/w/the-perfect-s-collection-by-sean-mcfirnn-sean-mcfirnn/1150827375?ean=2940196016240"],
    ["bookshop", "https://bookshop.org/p/books/the-perfect-s-collection-by-sean-mcfirnn-collection-sean-mcfirnn/696e1672eeba54dd?ean=9798235634343"],
    ["everand", "https://www.everand.com/book/1063279981/THE-PERFECT-S-COLLECTION-By-Sean-McFirnn-Collection"],
    ["fable", "https://fable.co/book/x-9798235634343"],
    ["kobo", "https://www.kobo.com/us/en/ebook/the-perfect-s-collection-by-sean-mcfirnn-collection?sId=d2ac19f1-2af8-4a0f-8649-845ab12c48db&ssId=z7fCSAiomLMeYBRREqu5v"],
    ["smashwords", "https://www.smashwords.com/books/view/2068340"],
    ["thalia", "https://www.thalia.de/shop/home/artikeldetails/A1080964068"],
    ["vivlio", "https://shop.vivlio.com/search?search=9798235634343"],
  ]),
};

export const storeLinksFor = (novelId) => STORE_LINKS[novelId] || [];
